<template>
    <div>
        <v-container v-if="responsive" class="ma-0 pa-0">
            <v-navigation-drawer app right hide-overlay=true v-model="menuVisible"
                                 class="pws-mobile-menu pws-background">
                <v-list class="py-0">
                    <template v-for="m in menu">
                        <v-list-tile class="pws-background" v-bind:key="m" v-if="!m.submenu">
                            <a :href="m.href">
                                <v-list-tile-title>{{ m.label }}</v-list-tile-title>
                            </a>
                        </v-list-tile>
                        <v-list-group v-bind:key="m" v-else class="pws-background">
                            <v-list-tile slot="activator">
                                <v-list-tile-title>{{ m.label }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-bind:key="sm" v-for="sm in m.submenu">
                                <a :href="sm.href">
                                    <v-list-tile-title class="ml-4">{{ sm.label }}</v-list-tile-title>
                                </a>
                            </v-list-tile>
                        </v-list-group>
                    </template>
                </v-list>
            </v-navigation-drawer>
            <v-toolbar fixed flat height=42 class="ma-0 pa-0 pws-mobile-toolbar pws-background">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-0 pa-0" @click="menuVisible = !menuVisible">
                    <v-icon x-large v-if="menuVisible">mdi-close</v-icon>
                    <v-icon x-large v-else>mdi-menu</v-icon>
                </v-btn>
            </v-toolbar>
            <div class="pws-mobile-logo">
                <a href>
                    <v-img :src="headerLogoSrc" :contain=true position="left" max-width="300"></v-img>
                </a>
            </div>
        </v-container>
        <v-container v-else class="px-0 pb-0" fluid justify-center>
            <v-layout justify-center align-center>
                <v-flex md8 lg6 :class="{'ml-4': $vuetify.breakpoint.mdAndDown}">
                    <a href>
                        <v-img :src="headerLogoSrc" :contain="true" :width=160></v-img>
                    </a>
                </v-flex>
                <v-flex md4 lg2 :class="{'mr-8': $vuetify.breakpoint.mdAndDown}">
                    <v-layout align-center>
                        <v-flex class="mr-2">
                            <v-btn color="primary" @click="goToLogin">
                                {{ $t('Core.Header.button-login') }}
                            </v-btn>
                        </v-flex>
                        <v-flex>
                            <div class="pws-support-info">
                                <div>{{ $t('Core.Header.opening-hours') }}</div>
                                <div>{{ $t('Core.Header.contact-phone') }}</div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout class="pws-nav mt-4" justify-center>
                <v-flex md12 lg8 class="ma-0 pa-0">
                    <template v-for="m in menu">
                        <div class="pws-nav-item" v-bind:key="m" v-if="!m.submenu" :style="{width: 100/6 + '%'}"
                             @click="openLink(m.href)">{{ m.label }}
                        </div>
                        <div class="pws-nav-item" v-bind:key="m" v-else :style="{width: 100/6 + '%'}">
                            <v-menu open-on-hover
                                    bottom
                                    content-class="dropdown-menu"
                                    offset-y
                                    transition="slide-y-transition"
                                    style="width:100%">
                                <span style="width:100%" slot="activator" class="toolbar-items">{{ m.label }}</span>
                                <v-list dense>
                                    <v-list-tile v-bind:key="sm" v-for="sm in m.submenu">
                                        <a :href="sm.href">
                                            <v-list-tile-title class="ml-4 pws-menu-item">{{ sm.label }}
                                            </v-list-tile-title>
                                        </a>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                </v-flex>
            </v-layout>
        </v-container>
        <v-parallax height="300" :src="publicPath + 'img/banner-polveri.jpg'"></v-parallax>
    </div>
</template>

<script>
    import i18n from '@/i18n'
    import {publicPath} from "../../../vue.config";

    export default {
        data() {
            return {
                responsive: false,
                menuVisible: false,
                publicPath: publicPath
            }
        },
        mounted() {
            this.onResponsiveInverted()
            window.addEventListener("resize", this.onResponsiveInverted)
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.onResponsiveInverted)
        },
        computed: {
            baseUrl() {
                return this.$t('Core.Header.base-url');
            },
            menu() {
                return [{
                    label: this.$t('Core.Header.nav-home'),
                    href: this.baseUrl + this.$t('Core.Header.link-home'),
                },
                    {
                        label: this.$t('Core.Header.nav-segments'),
                        submenu: [{
                            label: this.$t('Core.Header.nav-architectural'),
                            href: this.baseUrl + this.$t('Core.Header.link-architectural')
                        },
                            {
                                label: this.$t('Core.Header.nav-automotive'),
                                href: this.baseUrl + this.$t('Core.Header.link-automotive')
                            },
                            {
                                label:  this.$t('Core.Header.nav-general-industry'),
                                href: this.baseUrl + this.$t('Core.Header.link-general-industry')
                            },
                            {
                                label: 'ace',
                                href: this.baseUrl + this.$t('Core.Header.link-ace')
                            },
                            {
                                label: this.$t('Core.Header.nav-contract-painting'),
                                href: this.baseUrl + this.$t('Core.Header.link-contract-painting')
                            },
                            {
                                label: this.$t('Core.Header.nav-consumer-goods'),
                                href: this.baseUrl + this.$t('Core.Header.link-consumer-goods')
                            }]
                    },
                    {
                        label: this.$t('Core.Header.nav-research'),
                        href: this.baseUrl + this.$t('Core.Header.link-research')
                    },
                    {
                        label: this.$t('Core.Header.nav-news'),
                        href: this.baseUrl + this.$t('Core.Header.link-news')
                    },
                    {
                        label: this.$t('Core.Header.nav-about-us'),
                        href: this.baseUrl + this.$t('Core.Header.link-about-us')
                    },
                    {
                        label: this.$t('Core.Header.nav-contacts'),
                        href: this.baseUrl + this.$t('Core.Header.link-contact-us')
                    }]
            },
            headerLogoSrc() {
                return this.publicPath + 'img/LOGO-PULVERIT-WEB-' + i18n.locale + '.png'
            }
        },
        methods: {
            onResponsiveInverted() {
                this.responsive = window.innerWidth < 991;
            },
            openLink(url) {
                window.open(url, '_self')
            },
            goToLogin() {
                this.$router.push({name: 'Login'})
            },
        }
    }
</script>

<style scoped>
    .pws-background {
        background-color: #ee1020 !important;
        border-color: #ee1020 !important;
    }

    .pws-background >>> .v-icon {
        color: white !important;
    }

    .pws-background >>> .v-list__tile:hover {
        background-color: #848484 !important;
        border-color: #848484 !important;
    }

    .pws-background >>> .v-list__group__header:hover {
        background-color: #848484 !important;
        border-color: #848484 !important;
    }

    .pws-mobile-menu {
        margin-top: 42px !important;
    }

    .pws-mobile-menu div {
        text-transform: uppercase;
        color: white;
    }

    .v-toolbar {
        min-height: 42px;
        border-radius: 0px;
    }

    .pws-mobile-toolbar >>> .v-toolbar__content {
        min-height: 42px;
        padding: 0px 10px 0px 0px;
    }

    .pws-mobile-logo {
        margin-top: 42px;
        padding: 15px;
        max-width: 80%;
    }

    .container {
        background-color: white;
    }

    .pws-nav {
        border-top: 1px solid gray;
    }

    .pws-nav > div {
        display: flex;
    }

    .pws-nav-item {
        font-size: 11px;
        text-transform: uppercase;
        display: inline-block;
        text-align: center;
        transition: 0.5s;
        cursor: pointer;
        min-height: 35px;
        padding-top: 10px;
        border-right: 1px solid gray;
        border-bottom: 1px solid gray;
    }

    .pws-nav-item:first-child {
        border-left: 1px solid gray;
    }

    .pws-menu-item {
        color: black;
        text-transform: uppercase;
    }

    .pws-nav-item:hover {
        color: white;
        background-color: red;
    }

    .display-3 {
        text-transform: uppercase;
    }

    .pws-support-info {
        font-size: 11px;
        white-space: nowrap;
        text-transform: uppercase;
        min-width: 110px;
    }

    .pws-support-info > div:first-child {
        border-bottom: 1px solid red;
    }
</style>
